/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_All_DownloadsInputs */

const en_home_hero_all_downloads = /** @type {(inputs: Home_Hero_All_DownloadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All platforms and installation guide`)
};

/**
* | output |
* | --- |
* | "All platforms and installation guide" |
*
* @param {Home_Hero_All_DownloadsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_all_downloads = /** @type {((inputs?: Home_Hero_All_DownloadsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_All_DownloadsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_all_downloads(inputs)
});
export { home_hero_all_downloads as "home.hero.all_downloads" }